import { useState } from "react";

import { useIsMobile } from "@/hooks/useIsMobile";

/**
 * On mobile the QR code can't be scanned with the same device, so the
 * manual-key entry should be shown first instead of a QR code the user
 * can't use. Shared by the initial 2FA app setup and the "change 2FA
 * method" flow so both stay in sync.
 */
export const useManualSetupDefault = () => {
  const isMobile = useIsMobile();

  return useState(isMobile);
};
